import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { HeaderSection } from './BiasInfo';
import { handleError } from '../../../helpers/utils';
import { checkPossibleProcess } from '../../../actions/biases';

export const ProcessAction = ({
	action = null,
	currentBias,
	setDifferentArea = null,
}) => {
	// Current bias and subbiases
	const { biases = [] } = useSelector((state) => state.biases);
	const { area = '' } = useSelector((state) => state.user);

	const handleCheckOption = (option, finalArea) => {
		// Check if the final area is the same as the current area
		if (finalArea) {
			setDifferentArea(finalArea);
		} else {
			finalArea = area?.name;
		}

		// Check if the action is possible
		checkPossibleProcess(option, biases, finalArea, currentBias.id)
			.then(({ data }) => {
				if (data.ok) {
					if (data.is_valid) {
						action.handle(option, finalArea);
					} else {
						handleError(null, data.error);
					}
				} else {
					handleError(data.error, data.error);
				}
			})
			.catch((error) => {
				handleError(
					error,
					'Ocurrió un error al intentar checar las subpartidas'
				);
			});
	};

	return (
		<div style={{ padding: '25px' }}>
			{action && (
				<>
					{/* HEADER */}
					<HeaderSection text='Seleccionar acción' />

					<br />

					{/* SUBHEADER */}
					<Typography variant='p' gutterBottom>
						Selecciona la acción que quieres aplicar a las
						subpartidas.
					</Typography>

					<hr />

					<Grid container spacing={2}>
						{/* Opciones dinámicas dependiendo del área */}
						{area.name === 'Almacén y Requerimientos' && (
							<>
								{/* Opciones para Almacén y Requerimientos */}
								<Grid item xs={12}>
									<ButtonOption
										id='entry_date'
										label='Fecha de asignación'
										check={handleCheckOption}
									/>
								</Grid>
								<Grid item xs={12}>
									<ButtonOption
										id='final_date'
										label='Fecha de entrega'
										check={handleCheckOption}
									/>
								</Grid>

								{/* Opciones para iniciar "Avíos y Comercios" y "Tela" */}
								<Grid item xs={12}>
									<ButtonOption
										id='final_date'
										label='Avíos y Comercios - Fecha de entrega'
										area='Avíos y Comercios'
										check={handleCheckOption}
									/>
								</Grid>
								<Grid item xs={12}>
									<ButtonOption
										id='final_date'
										label='Tela - Fecha de entrega'
										area='Tela'
										check={handleCheckOption}
									/>
								</Grid>
							</>
						)}

						{/* Opciones para áreas "Avíos y Comercios" y "Tela" */}
						{area.name === 'Avíos y Comercios' && (
							<Grid item xs={12}>
								<ButtonOption
									id='entry_date'
									label='Avíos y Comercios - Fecha de inicio'
									check={handleCheckOption}
								/>
							</Grid>
						)}
						{area.name === 'Tela' && (
							<Grid item xs={12}>
								<ButtonOption
									id='entry_date'
									label='Tela - Fecha de inicio'
									check={handleCheckOption}
								/>
							</Grid>
						)}

						{/* Opciones para otras áreas no mencionadas */}
						{![
							'Almacén y Requerimientos',
							'Avíos y Comercios',
							'Tela',
						].includes(area.name) && (
							<>
								<Grid item xs={12}>
									<ButtonOption
										id='entry_date'
										label='Fecha de asignación'
										check={handleCheckOption}
									/>
								</Grid>
								<Grid item xs={12}>
									<ButtonOption
										id='final_date'
										label='Fecha de entrega'
										check={handleCheckOption}
									/>
								</Grid>
							</>
						)}

						{/* Botón de Cancelar */}
						<Grid item xs={12}>
							<Button
								fullWidth
								variant='contained'
								color='error'
								onClick={() => action.cancelAll()}
							>
								Cancelar
							</Button>
						</Grid>
					</Grid>
				</>
			)}
		</div>
	);
};

const ButtonOption = ({ id = '', label = '', check = null, area = null }) => (
	<Button
		onClick={() => check(id, area)}
		fullWidth
		size='large'
		color='primary'
		variant='outlined'
	>
		{label}
	</Button>
);
